import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useCreateNewModifierMutation } from "redux/modifiers/service";
import { errorHandler } from "api/api/errorHandler";
import { UTILS } from "utils";
import { isValidValue } from "utils/Utils";
import AppContainer from "components/ui/AppContainer";
import AppModal from "components/ui/AppModal";
import ModifierForm from "./components/ModifierForm";

const initialValues = {
  values: {
    baseLanguage: {
      name: "",
    },
    price: 0,
    imageURL: null,
    minimumOrderQuantity: 1,
    maximumOrderQuantity: 1,
    sku: "",
    isStockEnabled: false,
    availableStock: 0,
    lowStockThreshold: 0,
    translations: {
      en: {
        name: "",
      },
      ar: {
        name: "",
      },
    },
  },
  errors: {
    baseLanguage: {
      name: "",
    },
    price: "",
    minimumOrderQuantity: "",
    maximumOrderQuantity: "",
    isStockEnabled: "",
    availableStock: "",
    lowStockThreshold: "",
  },
}
// as: "create" or "update", "modal"
const AddModifierOption = ({ as = "create", onSuccess = () => { }, onClose = () => { }, open = false, title = "Create Modifier", subTitle = "Modifier Detail" }, ) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [createNewModifier] = useCreateNewModifierMutation();
  const [loading, setLoading] = useState(false);
  const [modifier, setModifier] = useState(initialValues);

  /* A function that is used to set the basic info in the state. */
  const handleBasicInfo = (key, val) => {
    setModifier((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        baseLanguage: {
          ...prevState.values.baseLanguage,
          [key]: val,
        },
        translations: {
          en: {
            name: val,
          },
          ar: {
            name: val,
          },
        },
      },
      errors: {
        ...prevState.errors,
        baseLanguage: {
          ...prevState.errors.baseLanguage,
          [key]: "",
        },
      },
    }));
  };

  /* A function that is used to set the basic info in the state. */
  const handleValues = (key, val) => {
    setModifier((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  /* Validating the inputs. */
  const validateInputs = () => {
    let isValid = true;
    let obj = {
      baseLanguage: {
        name: "",
      },
      price: "",
      minimumOrderQuantity: "",
      maximumOrderQuantity: "",
    };

    if (
      !modifier?.values?.baseLanguage?.name ||
      UTILS.hasWhiteSpace(modifier?.values?.baseLanguage?.name)
    ) {
      isValid = false;
      obj.baseLanguage.name = t("Enter modifier Name");
    }

    if (!isValidValue(modifier.values?.price)) {
      isValid = false;
      obj.price = t("Price is a required field");
    }

    if (!isValidValue(modifier?.values?.maximumOrderQuantity)) {
      isValid = false;
      obj.maximumOrderQuantity = t("Maximum Order Quantity is a requird field");
    }
    if (modifier?.values?.maximumOrderQuantity <= 0) {
      isValid = false;
      obj.maximumOrderQuantity = t(
        "Maximum Order Quantity must be greater zero"
      );
    }

    setModifier((prevState) => ({
      ...prevState,
      errors: obj,
    }));
    return isValid;
  };

  const createNewModifer = async () => {
    const isValid = validateInputs();
    if (!isValid) return;
    try {
      setLoading(true);
      const userDetail = UTILS.getCurrentUser();
      const data = await createNewModifier({
        brandId: userDetail.brandId,
        ...modifier?.values,
        price: +parseFloat(modifier?.values?.price).toFixed(2),
      });
      if (data?.data?.success === 1) {
        if (as === "modal") {
          setModifier(initialValues);
          onSuccess(data);
          return;
        }
        UTILS.successNotification(
          data?.data?.message ?? t("Modifier Created Successfully")
        );
        history.push("/app/dashboard/modifiers-list");
      } else {
        UTILS.errorNotification(errorHandler(data?.error?.data));
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.message));
    } finally {
      setLoading(false);
    }
  };

  const updatePrice = (key, val) => {
    const value = UTILS.NumberConversion(val);
    let Num = Number(value);
    handleValues(key, Num);
  };

  const Tag = as === "modal" ? AppModal : AppContainer;

  return (

    <Tag loading={loading} {...(as === "modal" ? { title: "Add New Customization Option", onClose: onClose, open: open } : { title: title, subTitle: subTitle })}>
      <ModifierForm
        modifier={modifier}
        handleBasicInfo={handleBasicInfo}
        handleValues={handleValues}
        onSave={createNewModifer}
        updatePrice={updatePrice}
        as={as}s
        showBackButton={as === "modal" ? false : true}
      />
    </Tag>
  );
};

AddModifierOption.propTypes = {
  handleValues: PropTypes.func,
  onClose: PropTypes.func,
  addModifierOption: PropTypes.func,
};
export default AddModifierOption;
